export default (remainingSeconds = 300) => ({
  remainingSeconds: remainingSeconds,
  timeToDisplay: '00:00',
  start: function () {
    this.setRemaining();
    this.intervalId = setInterval(() => {
      this.setRemaining();
    }, 1000);
    console.log(new Date(this.remainingSeconds * 1000).toISOString());
  },
  get isEnabled() {
    return this.remainingSeconds > 0;
  },
  get showTimeoutError() {
    return this.remainingSeconds <= 0;
  },
  setRemaining: function () {
    if (this.remainingSeconds <= 0) {
      clearInterval(this.intervalId);
      return '00:00';
    }
    this.remainingSeconds -= 1;
    this.timeToDisplay = new Date(this.remainingSeconds * 1000)
      .toISOString()
      .substring(14, 19);
  },
});
